module.exports = __webpack_public_path__ + "img/quayThresholdToVehicleTram.f87ed3e4.svg";